module.exports = __webpack_public_path__ + "static/img/img-1-1.d2a5caf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-1-1.png
// module id = Kc/c
// module chunks = 0